jQuery(document).ready(function ($) {
  "use strict";
  var handleFooter = function () {
    function footerAccordion() {
      var args = { duration: 250 };
      $(".footer-accordion .heading-accordion").on("click", function () {
        $(this).parent(".footer-accordion").toggleClass("open");
        if (!$(this).parent(".footer-accordion").is(".open")) {
          $(this).next().slideUp(args);
        } else {
          $(this).next().slideDown(args);
        }
      });
    };
    function handleAccordion() {
      if (matchMedia("only screen and (max-width: 767px)").matches) {
        if (
          !$(".footer-accordion .heading-accordion").data("accordion-initialized")
        ) {
          footerAccordion();
          $(".footer-accordion .heading-accordion").data(
            "accordion-initialized",
            true
          );
        }
      } else {
        $(".footer-accordion .heading-accordion").off("click");
        $(".footer-accordion .heading-accordion")
          .parent(".footer-accordion")
          .removeClass("open");
        $(".footer-accordion .heading-accordion").next().removeAttr("style");
        $(".footer-accordion .heading-accordion").data(
          "accordion-initialized",
          false
        );
      }
    }
    handleAccordion();
    window.addEventListener("resize", function () {
      handleAccordion();
    });
  };
  handleFooter();
});